import { css } from 'styled-components';
import { BADGE_SIZE, ROOT_GAP, ROOT_PADDING_LEFT, ROOT_PADDING_RIGHT, ROOT_PADDING_VERTICAL, } from '../tokens';
import { getIconSize } from '../utils';
import { badgeSize } from '../../../Badge/IconBadge/styles/utils';
export const controlPadding = ({ fieldSize, focused, hasIconLeft, hasIconRight, rows, showValidationBadge, validationState, }) => {
    let padVertical = 0;
    if (rows) {
        padVertical = focused
            ? ROOT_PADDING_VERTICAL[fieldSize] - 1
            : ROOT_PADDING_VERTICAL[fieldSize];
    }
    let padLeft = ROOT_PADDING_LEFT[fieldSize], padRight = ROOT_PADDING_RIGHT[fieldSize];
    if (hasIconLeft || hasIconRight) {
        const iconSize = getIconSize({ fieldSize });
        padLeft += hasIconLeft
            ? iconSize + ROOT_GAP[fieldSize]
            : 0;
        padRight += hasIconRight
            ? iconSize + ROOT_GAP[fieldSize]
            : 0;
    }
    if (showValidationBadge && validationState !== 'default') {
        padRight +=
            ROOT_GAP[fieldSize] +
                badgeSize(BADGE_SIZE[fieldSize]);
    }
    if (focused) {
        padLeft -= 1;
        padRight -= 1;
    }
    return css `
    padding: ${padVertical}px ${padRight}px ${padVertical}px ${padLeft}px;
  `;
};
